import React from 'react'
import { Link } from 'react-router-dom'


function Footer() {
  return (
    <footer>
      <div className='footer1'>

        <div className='h88'>
          <Link to={'/'} className='h55' >ՊՆԵՒՄՈՊՐՈ</Link><p>Պնևմոկախման նորոգման և վաճառքի մասնագետ՝ 15 <br /> տարվա փորձով</p> 
        </div>
        <nav className='kap'>
          <h4>Կապ</h4>
          <nav>

            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-phone h-4 w-4 text-primary"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg><a href="tel:+37494474816">+374 94 474816</a>
          </nav>
          <nav>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-mail h-4 w-4 text-primary"><rect width="20" height="16" x="2" y="4" rx="2"></rect><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path></svg><a href="mailto:armoo@rambler.ru">armoo@rambler.ru</a>
          </nav>
          <nav  >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-map-pin h-4 w-4 text-primary"><path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path><circle cx="12" cy="10" r="3"></circle></svg><a href="https://yandex.com/maps/-/CLvarJMZ" target='blank'   >Աշտարակ Տիգրան Մեծ 46/ա</a>
          </nav>

        </nav>
        <div>
          <h4 className='h56'>Աշխատանքային ժամեր</h4>
          <p>Երկ-Ուրբ: 9:00 - 18:00</p>
          <p>Շաբաթ: 10:00 - 16:00</p>
          <p>Կիրակի: 10:00 - 16:00</p>

        </div>

      </div>
      <hr />
      <div className='footer2'>
        <p >Design and development by G. Nersisyan 033017797</p>
      </div>

    </footer>
  )
}

export default Footer
